module.exports = __webpack_public_path__ + "img/line.cc27fec5.svg";